var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopNav'),_c('div',{attrs:{"id":"wrapper"}},[_c('SideBar'),_c('div',{attrs:{"id":"content-wrapper"}},[_vm._t("default"),_c('Footer')],2)],1),_c('LogoutModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }